







































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Event } from '../interfaces/event.interface';
import { EventModalParams } from '@/modules/events/interfaces/event-modal-params.interface';
import moment from 'moment';
import { http } from '@/plugins/axios';
import { AttendeeResponse } from '@/modules/events/interfaces/attendee-response.interface';
import { error, success } from '@/plugins/notification';

const eventStore = namespace('EventStore');
const userStore = namespace('UserStore');

@Component({ name: 'EventModal' })
export default class EventModalDetails extends Vue {
  @eventStore.State
  currentEvent!: Event;
  attendees: AttendeeResponse[] = [];
  @eventStore.State
  showEventDetailsModal?: boolean;
  @userStore.State
  isLogged?: boolean;
  @eventStore.Action
  updateEventDetailModalVisibility!: (params: EventModalParams) => void;
  showAttendees = false;

  get startDate() {
    return moment(this.currentEvent.startDate).calendar();
  }

  get endDate() {
    return moment(this.currentEvent.endDate).calendar();
  }

  get showSmallButton() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get hasAttendees() {
    return this.attendees.length > 0;
  }

  get attendeesTitle() {
    return `Attendees ${this.attendees.length}/${this.currentEvent.maxAttendees}`;
  }

  get getArrowIcon() {
    return this.showAttendees ? 'mdi-chevron-up' : 'mdi-chevron-down';
  }

  @Watch('showEventDetailsModal')
  updateAttendees() {
    if (this.showEventDetailsModal) {
      this.getAttendees();
    }
  }

  async getAttendees() {
    const response = await http.get(
      `/events/${this.currentEvent.id}/attendance`
    );
    this.attendees = response.data;
  }

  async attendToEvent() {
    if (this.isLogged) {
      await http.patch(`/events/${this.currentEvent.id}/attendance`);
      success('Attending!');
      await this.getAttendees();
      this.showAttendees = true;
    } else {
      error('Sign in first!');
    }
  }

  async cancelAttendance() {
    if (this.isLogged) {
      await http.delete(`/events/${this.currentEvent.id}/attendance`);
      success('Cancelled!');
      await this.getAttendees();
      this.showAttendees = true;
    } else {
      error('Sign in first!');
    }
  }

  formatDate(date: Date) {
    return moment(date).format('MMMM Do YYYY');
  }

  isAttendeePremium(attendee: AttendeeResponse) {
    return attendee.role === 'PREMIUM';
  }

  getAttendeeIconColor(attendee: AttendeeResponse) {
    return this.isAttendeePremium(attendee) ? 'amber' : 'grey';
  }

  onClose() {
    this.updateEventDetailModalVisibility({ show: false });
    this.showAttendees = false;
    if (!this.showEventDetailsModal) {
      this.attendees = [];
    }
  }
}
